if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        const selectionRequiredSection = this.closest('[data-require-variant-selection="true"]');
        const unselectedVariantGroup = Array.from(
          selectionRequiredSection?.querySelectorAll('.js.product-form__input') || []
        ).find(
          (group) =>
            group.querySelector("input[type='radio']") &&
            !group.querySelector("input[type='radio']:checked")
        );

        if (unselectedVariantGroup) {
          const selectionError = document.documentElement.lang?.toLowerCase().startsWith('ja')
            ? 'サイズを選択してください。'
            : 'Please select a size.';
          this.handleErrorMessage(selectionError);
          unselectedVariantGroup.querySelector("input[type='radio']:not(:disabled)")?.focus();
          return;
        }

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        const signatureGiftRoot = this.getSignatureGiftRoot();
        const signatureGiftRequest = signatureGiftRoot ? this.getSignatureGiftRequest(formData, signatureGiftRoot) : null;

        if (signatureGiftRequest && signatureGiftRequest.error) {
          this.handleErrorMessage(signatureGiftRequest.error);
          this.handleSignatureGiftError(signatureGiftRoot, signatureGiftRequest.error);
          this.submitButton.classList.remove('loading');
          this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading__spinner').classList.add('hidden');
          return;
        }

        if (this.cart) {
          const sections = this.cart.getSectionsToRender().map((section) => section.id);
          if (signatureGiftRequest) {
            signatureGiftRequest.body.sections = sections;
            signatureGiftRequest.body.sections_url = window.location.pathname;
          } else {
            formData.append('sections', sections);
            formData.append('sections_url', window.location.pathname);
          }
          this.cart.setActiveElement(document.activeElement);
        }

        if (signatureGiftRequest) {
          config.headers['Content-Type'] = 'application/json';
          config.body = JSON.stringify(signatureGiftRequest.body);
        } else {
          delete config.headers['Content-Type'];
          config.body = formData;
        }

        fetch(`${this.getCartAddUrl()}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              if (signatureGiftRoot) this.handleSignatureGiftError(signatureGiftRoot, response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            this.prepareCartNotificationResponse(response, formData.get('id'));

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      getCartAddUrl() {
        const cartAddUrl = routes.cart_add_url || '/cart/add.js';
        return /\.js(\?|$)/.test(cartAddUrl) ? cartAddUrl : `${cartAddUrl}.js`;
      }

      getSignatureGiftRoot() {
        const formId = this.form.getAttribute('id');
        const productInfo = this.form.closest('product-info') || document;
        const scopedRoot = formId
          ? productInfo.querySelector(`[data-signature-gift][data-product-form-id="${formId}"]`)
          : null;

        if (scopedRoot) return scopedRoot;

        const roots = Array.from(document.querySelectorAll('[data-signature-gift]'));
        return roots.length === 1 ? roots[0] : null;
      }

      getSignatureGiftRequest(formData, root) {
        const checkbox = root.querySelector('[data-signature-gift-checkbox]');
        const giftSelected = Boolean(checkbox && checkbox.checked);
        const messageActive = root.dataset.messageActive === 'true';

        if (!giftSelected && !messageActive) return null;

        this.handleSignatureGiftError(root);

        const quantity = this.getSignatureGiftQuantity(formData);
        if (giftSelected && quantity > 1) {
          return {
            error: [
              'LUSUP Signature Giftは商品1点につき1セットとなります。',
              'ギフトをご希望の場合は、数量を1にしてカートへ追加してください。',
              '複数点をご希望の場合は、1点ずつカートへ追加してください。',
            ].join('\n'),
          };
        }

        const messageModal = root.signatureGiftModals?.messageModal || document.querySelector('[data-signature-gift-message-modal]') || root.querySelector('[data-signature-gift-message-modal]');
        const messageInput = messageModal?.querySelector('[data-signature-gift-message-input]') || root.querySelector('[data-signature-gift-message-input]');
        const message = messageInput ? messageInput.value.trim() : '';

        if (messageActive && !message) {
          return { error: 'メッセージをご入力ください' };
        }

        if (message && /[\uD800-\uDFFF]|[\u2600-\u27BF]/.test(message)) {
          return { error: '絵文字・一部の特殊記号は使用できません。' };
        }

        const variantId = Number.parseInt(formData.get('id'), 10);
        if (!Number.isFinite(variantId)) return null;

        const properties = this.getSignatureGiftProperties(formData);
        if (giftSelected) properties['LUSUP Signature Gift'] = 'あり';
        if (messageActive && message) properties['メッセージカード'] = message;

        const productItem = {
          id: variantId,
          quantity,
        };

        if (Object.keys(properties).length) productItem.properties = properties;

        const sellingPlan = formData.get('selling_plan');
        if (sellingPlan) productItem.selling_plan = Number.parseInt(sellingPlan, 10);

        let items = [productItem];

        if (giftSelected) {
          const giftVariantId = Number.parseInt(root.dataset.giftVariantId, 10);
          if (!Number.isFinite(giftVariantId)) {
            return { error: 'LUSUP Signature Giftの商品バリアントIDを設定してください。' };
          }

          const giftItem = {
            id: giftVariantId,
            quantity: 1,
            properties: {
              '_対象商品': this.querySelector('.product__title h1')?.textContent?.trim() || document.querySelector('.product__title h1')?.textContent?.trim() || '商品',
            },
          };

          items = [giftItem, productItem];
        }

        return { body: { items } };
      }

      getSignatureGiftQuantity(formData) {
        const formValue = Number.parseInt(formData.get('quantity'), 10);
        if (Number.isFinite(formValue) && formValue > 0) return formValue;

        const input = document.querySelector(`[form="${this.form.id}"][name="quantity"]`) || this.form.querySelector('[name="quantity"]');
        const inputValue = Number.parseInt(input ? input.value : '1', 10);
        return Number.isFinite(inputValue) && inputValue > 0 ? inputValue : 1;
      }

      getSignatureGiftProperties(formData) {
        const properties = {};

        formData.forEach((value, key) => {
          const match = key.match(/^properties\[(.+)]$/);
          if (match && String(value).trim() !== '') {
            properties[match[1]] = String(value);
          }
        });

        return properties;
      }

      prepareCartNotificationResponse(response, productVariantId) {
        if (!response || response.key || !Array.isArray(response.items)) return response;

        const variantId = String(productVariantId);
        const productItem = response.items.find(
          (item) => String(item.variant_id ?? item.id) === variantId
        );
        const notificationHtml = response.sections?.['cart-notification-product'];

        if (notificationHtml) {
          const parsedHtml = new DOMParser().parseFromString(notificationHtml, 'text/html');
          const candidates = [productItem, ...response.items.filter((item) => item !== productItem)];
          const notificationItem = candidates.find(
            (item) => item?.key && parsedHtml.getElementById(`cart-notification-product-${item.key}`)
          );

          if (notificationItem?.key) {
            response.key = notificationItem.key;
            return response;
          }

          const renderedItem = parsedHtml.querySelector('[id^="cart-notification-product-"]');
          if (renderedItem) {
            response.key = renderedItem.id.replace('cart-notification-product-', '');
            return response;
          }
        }

        if (productItem?.key) response.key = productItem.key;
        return response;
      }

      handleSignatureGiftError(root, message = '') {
        const error = root.querySelector('[data-signature-gift-error]');
        if (!error) return;

        error.textContent = message;
        error.hidden = !message;
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
